// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"149":"073d1ff4","607":"c20eea69","865":"5d23003e"}[chunkId] + ".css";
};